import {
  createNotifier,
  NotificationGroup,
  defineNotificationComponent,
} from 'notiwind';
import { type CfgToastNotificationType } from '@cfgtech/ui';

export type NotificationSchema = {
  title: string;
  text: string;
  type: CfgToastNotificationType,
};

const notificator = createNotifier<NotificationSchema>();

export const notify = (schema: NotificationSchema, duration?: number): void => {
  notificator({
    ...schema,
    group: 'app',
  }, duration ?? 5000);
};

export const Notification = defineNotificationComponent<NotificationSchema>();
export { NotificationGroup };
